import { Box, Breadcrumbs, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import CollegeMangement from "../Colleges/CollegeMangement";
import Universites from "./Universites";
import Courses from "./Courses";
import Regulations from "./Regulations";
import Staets from "./States";
import Lookups from "./Lookups";
import SubjectCategories from "./SubjectCategories";
import Publications from "./Publications";
import ExamReminders from "./ExamReminders";
import ExamTimeTable from "./ExamTimeTable";
import Blogs from "./Blogs";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: { xs: 1, md: 3 } }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Academics() {
  const [value, setValue] = React.useState(
    Number(localStorage.getItem("academicsTabIndex")) || 0,
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem("academicsTabIndex", newValue);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: { xs: "flex-start", md: "space-between" },
          alignItems: { xs: "stretch", md: "center" },
          gap: { xs: 1, md: 0 },
          mb: 2,
          mt: 1,
          marginLeft: "10px",
        }}
      >
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
          <Link underline="hover" color="inherit" to="/booklist">
            Books List
          </Link>
          <Typography sx={{ color: "text.primary", fontWeight: 600 }}>
            Academics Management
          </Typography>
        </Breadcrumbs>
      </Box>

      <Box sx={{ width: "100%", overflowX: "auto" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="basic tabs example"
            TabIndicatorProps={{
              style: {
                backgroundColor: "#17479e",
                height: 2,
              },
            }}
            sx={{
              "& .MuiTab-root": {
                color: "#555",
                fontWeight: 600,
                textTransform: "none",
                minWidth: "120px", // mobile friendly
              },
              "& .Mui-selected": {
                color: "#17479e !important",
              },
            }}
          >
            <Tab value={0} label="Universities" {...a11yProps(0)} />
            <Tab value={1} label="Courses" {...a11yProps(1)} />
            <Tab value={2} label="Regulations" {...a11yProps(2)} />
            <Tab value={3} label="Colleges" {...a11yProps(3)} />
            <Tab value={4} label="States" {...a11yProps(4)} />
            <Tab value={5} label="Look Ups" {...a11yProps(5)} />
            <Tab value={6} label="Subject Categories" {...a11yProps(6)} />
            <Tab value={7} label="Publications" {...a11yProps(7)} />
            {/* <Tab value={8} label="ExamReminders" {...a11yProps(8)} /> */}
            <Tab value={9} label="Exam Time Table" {...a11yProps(9)} />
            <Tab value={10} label="Other Courses" {...a11yProps(10)} />
            <Tab value={11} label="Other Universities" {...a11yProps(11)} />
            <Tab value={12} label="Blogs" {...a11yProps(12)} />
          </Tabs>
        </Box>

        <CustomTabPanel
          value={value}
          index={0}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <Universites />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={1}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <Courses />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={2}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <Regulations />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={3}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <CollegeMangement />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={4}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <Staets />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={5}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <Lookups />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={6}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <SubjectCategories />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={7}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <Publications />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={8}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <ExamReminders />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={9}
          style={{ overflowY: "auto", maxHeight: "92vh" }}
        >
          <ExamTimeTable />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={10}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <Courses active={false} />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={11}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <Universites active={false} />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={12}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <Blogs />
        </CustomTabPanel>
      </Box>
    </>
  );
}

export default Academics;
